// extracted by mini-css-extract-plugin
export default {"contentLink":"markdown_contentLink__dZng8"};